import { format, parse } from 'date-fns'
import { mapState } from 'vuex'

const toIsoDate = (value) =>
  value ? format(parse(value, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd') : null

export default {
  components: {
    HeaderBlock: () => import('~/components/commom/header/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    lifeInsuranceForm: () =>
      import('~/components/layouts/life-insurance-form/index')
  },
  async fetch({ store }) {
    if (store.state.team.members.length === 0) {
      await store.dispatch('team/getTeam')
    }
  },
  data() {
    return {
      activeStep: 0,
      lifeData: {},
      isSending: false
    }
  },
  computed: {
    ...mapState(['auth']),
    teamMember() {
      return this.$store.state.team.members[0]
    },
    simulationData() {
      return {
        name: `${this.lifeData.firstName} ${this.lifeData.lastName}`.trim(),
        email: this.lifeData.email,
        phone: this.lifeData.phone.toString(),
        dob: toIsoDate(this.lifeData.applicantDateOfBirth),
        dob2: toIsoDate(this.lifeData.secondApplicantDateOfBirth),
        amount: this.lifeData.owedValue,
        tan: this.lifeData.tan,
        applicants: parseInt(this.lifeData.numberOfApplicants, 10),
        term: this.lifeData.numberOfLownYears,
        premium: this.lifeData.currentPremium,
        indexation: this.lifeData.indexation,
        spread: this.lifeData.spread,
        bankCompanyId: this.lifeData.bank,
        profession: this.lifeData.profession
      }
    }
  },

  methods: {
    isStepActive(index) {
      return index === this.activeStep
    },

    goToNextStep() {
      this.$gtm.pushEvent({
        event:
          this.activeStep === 0
            ? 'life_simulation_start'
            : 'life_simulation_completed'
      })

      this.activeStep++
      window.scrollTo(0, 0)
    },

    submitForm() {
      if (this.isSending) {
        return
      }

      this.isSending = true

      this.sendToServer()
        .then((response) => {
          this.isSending = false

          this.$gtm.pushEvent({
            event: 'life_simulation'
          })

          return this.handleSucessSubmission(response.data)
        })
        .catch((_error) => {
          this.isSending = false
        })
    },

    sendToServer() {
      return this.$axios.post('life-insurance/quotes', this.simulationData, {
        baseURL: process.env.API_V2_BASE_URL,
        headers: {
          'Content-type': 'application/json; charset=utf-8'
        },
        withCredentials: true
      })
    },

    handleSucessSubmission(response) {
      this.saveSimulationOnStorage(response.uuid)
      this.saveSimulationData(this.simulationData)
      this.$router.push(
        this.localePath({
          name: 'simulacao-seguro-vida-resultados-id',
          params: {
            id: response.uuid
          }
        })
      )
    },
    saveSimulationData(simulationData) {
      return this.$store.commit('localStorage/SAVE_SIMULATION_DATA', {
        simulationData
      })
    },
    saveSimulationOnStorage(id) {
      if (this.auth.isLoggedIn) {
        return
      }

      return this.$store.commit('localStorage/ADD_ANONYMOUS_LIFE_SIMULATION', {
        id
      })
    }
  }
}
